import { PeopleBuyingTeam } from '@aibees/elephant/components/people-buying-team';
import { useCompanyReadDataContext } from '@aibees/elephant/context';
import { useSearchFiltersStore } from '@aibees/elephant/feature/search-filters/store';
import { CompanySave } from '@aibees/elephant/feature/search-table-company/components/company-save';
import { useCompanySearchItemsStore } from '@aibees/elephant/feature/search-table-company/store';
import { IconButton } from '@aibees/shared/components';
import { useTableSearchItemStore } from '@aibees/shared/store/table-search-item';
import { classnames } from '@aibees/shared/utils';
import { Stack } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import { Navigation, HeaderNavigationProps as Props } from './types';
import { useCurrentCompanyData } from '../company-summary/hooks/use-current-company-data';
import { ViewFullProfile } from '@aibees/elephant/components/view-full-profile';

export const HeaderNavigation = memo(({ className, drawerState }: Props) => {
  const { companySearchItems } = useCompanySearchItemsStore();
  const { setSelectedItem } = useTableSearchItemStore();
  const { setSelectedItemId, selectedItemId } = useSearchFiltersStore();
  const { api } = useCompanyReadDataContext();
  const { fullProfileLink } = useCurrentCompanyData();

  const [itemIndex, setItemIndex] = useState<number>(
    companySearchItems.findIndex((item) => item.id === selectedItemId) ?? 0
  );

  useEffect(() => {
    const currentItemIndex = companySearchItems.findIndex(
      (item) => item.id === selectedItemId
    );
    setItemIndex(currentItemIndex);
  }, [companySearchItems, selectedItemId]);

  const handleNavigation = (navigate: Navigation) => {
    const currentItemIndex = companySearchItems.findIndex(
      (item) => item.id === selectedItemId
    );
    const navIndex =
      navigate === Navigation.NEXT
        ? currentItemIndex + 1
        : currentItemIndex - 1;
    setSelectedItemId(companySearchItems[navIndex].id);
    setSelectedItem(companySearchItems[navIndex].id);
  };

  return (
    <Styled.Wrapper
      className={classnames('HeaderNavigation', className)}
      sx={SX.root}
      direction="row"
      justifyContent="space-between"
    >
      <Stack direction="row" alignItems="center" gap={0.5}>
        <CompanySave item={api?.data} />
        <ViewFullProfile link={fullProfileLink} size="small" />
        {api?.data && <PeopleBuyingTeam personId={api?.data?.id} isSideBar />}
      </Stack>
      <Stack direction="row" alignItems="center" gap={0.5}>
        <Stack direction="row" alignItems="center" gap={0.5}>
          <IconButton
            onClick={() => handleNavigation(Navigation.PREV)}
            disabled={itemIndex === 0}
            variant="outlined"
            icon={'chevron-up'}
            iconColor="default"
            size="xsmall"
          />
          <IconButton
            onClick={() => handleNavigation(Navigation.NEXT)}
            disabled={itemIndex === companySearchItems.length - 1}
            variant="outlined"
            icon={'chevron-down'}
            iconColor="default"
            size="xsmall"
          />
        </Stack>
        <IconButton
          onClick={drawerState?.onFalse}
          icon="close"
          color="default"
          iconSize={16}
          size="xsmall"
        />
      </Stack>
    </Styled.Wrapper>
  );
});

HeaderNavigation.displayName = 'HeaderNavigation';
